import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router"

if (location.hostname.match(/(rach.kings.kucits.ca)|(tomo.kings.kucits.ca)/gi)) {
  Vue.config.devtools = true
  Vue.config.productionTip = false
}

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
